import {downloadFile, downloadPdfFile} from "@/utils/filesUtil";
import moment from "moment";
import patientService from "@/services/patientService";
import metricsService from "@/services/metricsService";
import store from "@/store";
import sweetalertUtil from "@/utils/sweetalertUtil";


const useDownloads = () => {


    const downloadExcelReportPatientInformation = async (params = {}) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = "informacion-usuarios-"
    
        const response = await patientService.getExcelUserInformation(params);
        downloadFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadExcelReportInitialAndSubsequentsEvaluations = async () => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = "evaluaciones-iniciales-subsecuentes-"
    
        const response = await metricsService.downloadInitialSubsequentEvaluationReport(null);
        downloadFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadExcelReportWaitingList = async () => {

        console.log("composable");

        store.commit('setGeneralIsLoading', true)
    
        const fileName = "lista-de-espera-"
    
        const response = await metricsService.downloadWaitingListReport(null);
        downloadFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const openWeeklyClientsReportModal = () => {
        const downloadModal = document.querySelector('#weeklyReportDownload')
        const modal = bootstrap.Modal.getOrCreateInstance(downloadModal)
        modal.show()
    }

    const downloadReportClientsWeekly = async (params) => {        
        if (!params || params.tenant_id == null) {
            sweetalertUtil.fire({
                icon: "danger",
                text: "Debes seleccionar una empresa"
            });
            return;
        }
        store.commit('setGeneralIsLoading', true)
    
        const fileName = "weekly-report-"
    
        const response = await metricsService.downloadWeeklyUsersReport(params);
        downloadPdfFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)        
    
        store.commit('setGeneralIsLoading', false)
    }

    const downloadExcelRegisteredUsers = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = "usuarios-registrados-"
    
        const response = await metricsService.downloadRegisteredUsersReport(params);
        downloadFile(response.data, `${fileName}${moment().format("DD_MM_YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadAllSessionsBySesionDateReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
        const fileName = `Sesiones agendadas por fecha de sesion rango de fechas ${formatDate(params.from)} a ${formatDate(params.to)}`
    
        const response = await metricsService.downloadAllSessionsReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadAllSessionsByCreatedAtReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Sesiones agendadas por fecha de creacion rango de fechas ${formatDate(params.from)}-${formatDate(params.to)}`
    
        const response = await metricsService.downloadAllSessionsReport({...params, filter_created: true});
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadConsultationReasonsReport = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Motivos de consulta rango de fechas ${formatDate(params.from)} a ${formatDate(params.to)}`
    
        const response = await metricsService.downloadConsultationReasonsReport(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    
    }

    const downloadExitQuestions2Report = async (params) => {

        store.commit('setGeneralIsLoading', true)
    
        const fileName = `Preguntas de salida 2.0`
    
        const response = await metricsService.downloadExitQuestions2Report(params);
        downloadFile(response.data, `${fileName} fecha descarga ${moment().format("DD-MM-YYYY")}`)
    
        store.commit('setGeneralIsLoading', false)
    }

    const formatDate = (date) => {
        return moment(date, 'YYYY/mm/dd').format('YYYY-MM-DD')
    }

    return {
        downloadExcelReportPatientInformation,
        downloadExcelReportInitialAndSubsequentsEvaluations,
        downloadExcelReportWaitingList,
        openWeeklyClientsReportModal,
        downloadReportClientsWeekly,
        downloadExcelRegisteredUsers,
        downloadAllSessionsBySesionDateReport,
        downloadAllSessionsByCreatedAtReport,
        downloadConsultationReasonsReport,
        downloadExitQuestions2Report
    }

}

export default useDownloads;
